import React, { useState, useEffect } from 'react';

import { useForm } from 'react-hook-form';
import { statusOrgaoEnum } from '../../constants'
import {
    GlobalContainer,
    ContentContainer,
    ContentContainerBlock,
    ContentContainer1,
    ContentContainer11,
    ContentContainer12,
    ContentContainer13,
    InputContainerCheckbox,
    Title,
    TitleContainer,
    ContentContainerButtons,
    SelectContainer,
    Mandatory,
    SelectContainerLeftMargin
} from './styles';
import Select, { components } from 'react-select';
import ModalCancel from '../Modal/Cancel/index';
import DropDownIcon from '../../assets/drop_down_icon.png';
import DropUpIcon from '../../assets/drop_up_icon.png';
import FailIcon from '../../assets/fail_icon.png';
import ModalError from '../Modal/Error';
import ModalSuccess from '../Messages/Success/index';
import { agencyScopeEnum } from '../../constants';
import ModalFormAddWorkingHours from '../Modal/Form/ModalFormAddWorkingHours';
import { horarioPadraoLabelFactory, formatDateDDMMYYYY } from '../../utils';
import { estados } from '../../constants'
import ModalConfirm from '../Modal/Confirm/index';

export default function AgencyEntity(props) {
    const [defaultFormValues, setDefaultFormValues] = useState({
        nome_orgao: "",
        nome_rede_atendimento: "",
        abrangencia: "",
        orgaos_autorizados: "",
        horarios: [],
        atendimento_presencial: false,
        data_credenciamento: "",        
        referencia_autorizacao: "",
        realiza_atendimento: false 
    });
    const [horarioPadraoAtendimento, setHorarioPadraoAtendimento] = useState();
    const [restricaoUsuariosLotacao, setRestricaoUsuariosLotacao] = useState(false);
    let agencyScopeOptions =
        Object.entries(agencyScopeEnum.getLabels)
            .filter(([key, value]) => key !== "getLabelByValue") // remove o método 'getLabelByValue'
            .map(([key, value]) => ({
                value: key,
                label: value
            }));
    const [showErroAgencyName, setShowErroAgencyName] = useState(false);
    const [showErroAgencyPopularName, setShowErroAgencyPopularName] = useState(false);
    const [showErroAgencyScope, setShowErroAgencyScope] = useState(false);
    const [showErroUF, setShowErroUF] = useState(false);
    const [showErroMunicipality, setShowErroMunicipality] = useState(false);
    const [showErroAgencyWorkingHours, setShowErroAgencyWorkingHours] = useState(false);
    const [showErroAgencyReferenciaAutorizacao, setShowErroAgencyReferenciaAutorizacao] = useState(false);
    const [showErroOrgaoAutorizado, setShowErroOrgaoAutorizado] = useState(false)
    const [isModalAdicionarNovoHorarioVisible, setModalAdicionarNovoHorarioVisible] = useState(false);
        
    const isAllFieldsValidated = () => {
        if (!defaultFormValues?.nome_rede_atendimento?.trim()) {
            setShowErroAgencyPopularName(true);
            document.documentElement.scrollTop = 0;
            return false;
        }
        if (!defaultFormValues?.nome_orgao?.trim()) {
            setShowErroAgencyName(true);
            document.documentElement.scrollTop = 0;
            return false;
        }
        if (!(defaultFormValues?.abrangencia)) {
            setShowErroAgencyScope(true);
            document.documentElement.scrollTop = 0;
            return false;
        }
        if ((defaultFormValues?.abrangencia === 'ESTADUAL') && !defaultFormValues?.uf) {
            setShowErroUF(true);
            document.documentElement.scrollTop = 0;
            return false;
        }
        if ((defaultFormValues?.abrangencia === 'MUNICIPAL') && !defaultFormValues?.uf) {
            setShowErroUF(true);
            document.documentElement.scrollTop = 0;
            return false;
        }
        if ((defaultFormValues?.abrangencia === 'MUNICIPAL') && !defaultFormValues?.codigo_municipio) {
            setShowErroMunicipality(true);
            document.documentElement.scrollTop = 0;
            return false;
        }
        if (defaultFormValues?.horarios.length === 0) {
            setShowErroAgencyWorkingHours(true);
            document.documentElement.scrollTop = 0;
            return false;
        }
        if (!(defaultFormValues?.referencia_autorizacao?.trim()) && defaultFormValues?.data_credenciamento) {
            setShowErroAgencyReferenciaAutorizacao(true);
            document.body.scrollTop = 0;
            return false;
        }
        if (restricaoUsuariosLotacao && !(defaultFormValues?.orgaos_autorizados?.trim().length > 0)) {
            setShowErroOrgaoAutorizado(true);
            return false;
        }
                            
        return true;
    }
    const { handleSubmit } = useForm({ defaultFormValues });
    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                {props.selectProps.menuIsOpen
                    ? <img src={DropUpIcon} alt="upicon" />
                    : <img src={DropDownIcon} alt="downicon" />
                }
            </components.DropdownIndicator>
        );
    };
    const IndicatorSeparator = ({ innerProps }) => <span style={{}} {...innerProps} />;
    const [isModalCancelVisible, setModalCancelVisible] = useState(false);
    const [isModalAccreditationDateWithoutPermissionVisible, setModalAccreditationDateWithoutPermissionVisible] = useState(false);
    const [isModalPermissionWithoutAccreditationDateVisible, setModalPermissionWithoutAccreditationDateVisible] = useState(false);
    const [isModalPermissionUncheckedWarningVisible, setModalPermissionUncheckedWarningVisible] = useState(false);
    const [isModalUserByAllocationRestrictionUncheckedWarningVisible, setModalUserByAllocationRestrictionUncheckedWarningVisible] = useState(false);

    useEffect(() => {
        window.scroll({ top: 0 }); //Importante para forçar a rolagem para o topo da tela ao ser carregada de uma tela anterior rolada para abaixo. 
        if (props.agency) {
            setDefaultFormValues({...props.agency, 
                atendimento_presencial: (props.agency.atendimento_presencial === 'S' ? true : false),
                realiza_atendimento: (props.agency.realiza_atendimento === 'S' ? true : false)
            });  
            setRestricaoUsuariosLotacao(props.agency.orgaos_autorizados?.trim().length > 0);
            if (props.agency?.horarios?.length > 0) setHorarioPadraoAtendimento(horarioPadraoLabelFactory(props.agency.horarios))
        }
    }, [props.agency])

    // ESTILIZACAO PARA O SELECT ======================================================
    const SelecStyles = {
        control: (defaultStyles, state) => ({
            ...defaultStyles,
            borderWidth: state.isFocused ? 2.5 : 1,
            borderColor: state.isFocused ? '#E60000' : '#888',
            '&:hover': {
                backgroundColor: '#C5D4EB',
            },
            marginTop: 6,
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            fontSize: 13.5,
            fontWeight: 355,
            marginLeft: 7,
            fontStyle: 'italic',
        }),
    };   
    // ================================================================================

    return (
        <>
            <ModalCancel
                id="modalcancelalert"
                appear={isModalCancelVisible}
                text={"Tem certeza que deseja cancelar a operação?"}
                actionButton1={() => setModalCancelVisible(false)}
                actionButton2={() => props.history.push(props.buttonCancelRoute, props.buttonCancelRouteToDataState)}
            />
            <ModalFormAddWorkingHours
                id="modaladicionarnovohorario"
                appear={isModalAdicionarNovoHorarioVisible}
                setModalAdicionarNovoHorarioVisible={setModalAdicionarNovoHorarioVisible}
                defaultFormValues={defaultFormValues}
                setDefaultFormValues={setDefaultFormValues}
                setShowErroAgencyWorkingHours={setShowErroAgencyWorkingHours}
                horarioPadraoAtendimento={horarioPadraoAtendimento}
                setHorarioPadraoAtendimento={setHorarioPadraoAtendimento}
                workingHoursOptions={props.workingHoursOptions}
                setWorkingHoursOptions={props.setWorkingHoursOptions}
                textButton1="Cancelar"
                textButton2="Adicionar"
            />
            <ModalError
                id="modalconfirmalert"
                appear={props.modalError}
                text={props.messageError}
                actionButton2={() => props.setModalError(false)}
                history={props.history}
                location={props.location}
            />
            <ModalConfirm
                id="modalAccreditationDateWithoutPermissionconfirmlert"
                appear={isModalAccreditationDateWithoutPermissionVisible}
                title=""
                text='<p>Você informou a data de credenciamento/autorização, mas não marcou a opção <b>"Autorizada a realizar atendimento"</b>.</p><p>Sem essa autorização, a rede de atendimento não poderá realizar atendimentos até que seja autorizada. Deseja prosseguir mesmo assim?</p>'
                textButton1="Cancelar"
                actionButton1={() => setModalAccreditationDateWithoutPermissionVisible(false)}
                textButton2="Sim"
                actionButton2={(e) => { document.getElementById("submitForm").requestSubmit(); setModalAccreditationDateWithoutPermissionVisible(false); }}
                textButton3="Sim"
            />
            <ModalConfirm
                id="modalPermissionWithoutAccreditationDateVisible"
                appear={isModalPermissionWithoutAccreditationDateVisible}
                title=""
                text='<p>Você marcou a opção <b>"Autorizada a realizar atendimento"</b>, mas não informou a data de credenciamento/autorização.</p><p>Isso autoriza a rede a realizar atendimentos sem registro de credenciamento. Deseja prosseguir mesmo assim?</p>'
                textButton1="Cancelar"
                actionButton1={() => setModalPermissionWithoutAccreditationDateVisible(false)}
                textButton2="Sim"
                actionButton2={(e) => { document.getElementById("submitForm").requestSubmit(); setModalPermissionWithoutAccreditationDateVisible(false); }}
                textButton3="Sim"
            />
            <ModalConfirm
                id="modalPermissionUncheckedWarningVisible"
                appear={isModalPermissionUncheckedWarningVisible}
                title=""
                text='<p>Você desmarcou o campo <b>"Autorizada a realizar atendimento"</b>. Sem essa autorização, a rede de atendimento não poderá realizar atendimentos até que seja novamente autorizada. Deseja prosseguir mesmo assim?</p>'
                textButton1="Cancelar"
                actionButton1={() => setModalPermissionUncheckedWarningVisible(false)}
                textButton2="Sim"
                actionButton2={(e) => { setDefaultFormValues({ ...defaultFormValues, realiza_atendimento: false }); setModalPermissionUncheckedWarningVisible(false); }}
                textButton3="Sim"
            />
            <ModalConfirm
                id="modalUserByAllocationRestrictionUncheckedWarningVisible"
                appear={isModalUserByAllocationRestrictionUncheckedWarningVisible}
                title=""
                text='<p>Você desmarcou o campo <b>"Restringir o cadastro de usuários por lotação"</b>. Sem essa restrição, qualquer pessoa pode ser cadastrada como usuário do balcão gov.br independentemente dela ser servidora pública ou não. Deseja prosseguir mesmo assim?</p>'
                textButton1="Cancelar"
                actionButton1={() => setModalUserByAllocationRestrictionUncheckedWarningVisible(false)}
                textButton2="Sim"
                actionButton2={(e) => { setRestricaoUsuariosLotacao(!restricaoUsuariosLotacao); setDefaultFormValues({ ...defaultFormValues, orgaos_autorizados: null }); setModalUserByAllocationRestrictionUncheckedWarningVisible(false); }}
                textButton3="Sim"
            />

            <GlobalContainer>
                {props.fromSuccessMsg &&
                    <ModalSuccess text={props.fromSuccessMsg}/>
                }
                <form id="submitForm" onSubmit={handleSubmit(() => { if (isAllFieldsValidated()) props.onSubmitData(defaultFormValues); } ) }>
                    <ContentContainer>
                        <ContentContainer1>
                            <TitleContainer>
                                <Title> {props.pageTitle} </Title>
                                <Title><label>Status atual: {props.agency?.status_orgao ? statusOrgaoEnum.getLabelByValue(props.agency?.status_orgao) : statusOrgaoEnum.getLabelByDate(defaultFormValues.data_credenciamento)}</label></Title>                                        
                            </TitleContainer>
                            <label>Dados da rede de atendimento</label>
                            <ContentContainer12>
                                <ContentContainer13>
                                    <ContentContainer11>
                                        <div className="br-input">                                                    
                                            {props.onSubmitData &&
                                                <>
                                                    <label htmlFor="nome_rede_atendimento">Nome da rede de atendimento<Mandatory>*</Mandatory></label>
                                                    <input
                                                        id="nome_rede_atendimento-input"
                                                        name="nome_rede_atendimento"
                                                        type="text"
                                                        maxlength="200"
                                                        data-input="data-input"
                                                        placeholder="Informe nome da rede de atendimento"
                                                        defaultValue={defaultFormValues.nome_rede_atendimento}
                                                        onInput={e => { setDefaultFormValues({ ...defaultFormValues, nome_rede_atendimento: e.target.value }); setShowErroAgencyPopularName(false); }} //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                        style={{
                                                            "padding": "0px 7px 0px",
                                                            "fontSize": "14px",
                                                            "fontWeight": "normal",
                                                            "color": "#333333"
                                                        }}
                                                    />
                                                    {showErroAgencyPopularName &&
                                                        <span className="feedback danger" role="alert">
                                                            <i className="fas fa-times-circle" aria-hidden="true">
                                                                <img
                                                                    src={FailIcon}
                                                                    style={{ paddingBottom: '5px' }}
                                                                    alt="failicon"
                                                                />
                                                            </i>
                                                            Este campo é obrigatório.
                                                        </span>}
                                                </>
                                            }
                                            {!props.onSubmitData &&
                                                <>
                                                    <label htmlFor="nome_rede_atendimento">Nome da rede de atendimento</label>
                                                    <div style={{'width': '130ch', 'overflowWrap': 'anywhere', 'wordBreak': 'breakWord', 'whiteSpace': 'normal'}}>
                                                        <span>{props.agency.nome_rede_atendimento}</span> 
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </ContentContainer11>
                                    <ContentContainer11>
                                        <div className="br-input">                                                    
                                            {props.onSubmitData &&
                                                <>
                                                    <label htmlFor="nome_orgao">Nome do órgão/entidade responsável<Mandatory>*</Mandatory></label>
                                                    <input
                                                    id="nome_orgao-input"
                                                    name="nome_orgao"
                                                    type="text"
                                                    maxlength="200"
                                                    data-input="data-input"
                                                    placeholder="Informe nome do órgão/entidade"
                                                    defaultValue={defaultFormValues.nome_orgao}
                                                    onInput={e => { setDefaultFormValues({ ...defaultFormValues, nome_orgao: e.target.value }); setShowErroAgencyName(false); }} //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                    style={{
                                                        "padding": "0px 7px 0px",
                                                        "fontSize": "14px",
                                                        "fontWeight": "normal",
                                                        "color": "#333333"
                                                    }}
                                                    />
                                                    {showErroAgencyName &&
                                                        <span className="feedback danger" role="alert">
                                                            <i className="fas fa-times-circle" aria-hidden="true">
                                                                <img
                                                                    src={FailIcon}
                                                                    style={{ paddingBottom: '5px' }}
                                                                    alt="failicon"
                                                                />
                                                            </i>
                                                            Este campo é obrigatório.
                                                        </span>}
                                                </>
                                            }
                                            {!props.onSubmitData &&
                                                <>
                                                    <label htmlFor="nome_orgao">Nome do órgão/entidade responsável</label>
                                                    <div style={{'width': '130ch', 'overflowWrap': 'anywhere', 'wordBreak': 'breakWord', 'whiteSpace': 'normal'}}>
                                                        <span>{props.agency.nome_orgao}</span>
                                                    </div>
                                                </>
                                            }                                                    
                                        </div>
                                    </ContentContainer11>
                                    
                                    {props.onSubmitData &&
                                        <ContentContainerBlock>
                                            <SelectContainer>
                                                <label>Abrangência do atendimento<Mandatory>*</Mandatory></label>                                                            
                                                    <Select
                                                        onChange={(value) => {
                                                            setDefaultFormValues({ ...defaultFormValues, abrangencia: value.value, uf: undefined, codigo_municipio: undefined });
                                                            if (value) {
                                                                setShowErroAgencyScope(false); //Limpa erro
                                                            }
                                                        }}
                                                        options={agencyScopeOptions}
                                                        value = {agencyScopeOptions.find(obj => obj.value === defaultFormValues.abrangencia)}
                                                        placeholder="Selecione a abrangência"
                                                        styles={SelecStyles}
                                                        theme={theme => ({
                                                            ...theme,
                                                            borderRadius: 6,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: '#CCCCCC',
                                                                primary: '#1351B4'
                                                            },
                                                        })}
                                                        components={
                                                            {
                                                                DropdownIndicator,
                                                                IndicatorSeparator
                                                            }
                                                        }
                                                    />
                                                    {showErroAgencyScope &&
                                                    <span className="feedback danger" role="alert" id="cpfoperator">
                                                        <i className="fas fa-times-circle" aria-hidden="true">
                                                            <img
                                                                src={FailIcon}
                                                                style={{ paddingBottom: '5px' }}
                                                                alt="failicon"
                                                            />
                                                        </i>
                                                        Este campo é obrigatório.
                                                    </span>}                                                        
                                            </SelectContainer> 

                                            {props.stateOptions && ((defaultFormValues.abrangencia === 'ESTADUAL') || (defaultFormValues.abrangencia === 'MUNICIPAL')) &&
                                                <SelectContainerLeftMargin>
                                                    <label>Estado (UF)<Mandatory>*</Mandatory></label>                                                            
                                                        <Select
                                                            onChange={(value) => {
                                                                setDefaultFormValues({ ...defaultFormValues, uf: value.value, codigo_municipio: undefined });
                                                                if (value) {
                                                                    props.listMunicipality(value.value)
                                                                    setShowErroUF(false); //Limpa erro
                                                                }
                                                            }}
                                                            isDisabled={props.loadingMunicipality}
                                                            options={props.stateOptions}
                                                            value={ (defaultFormValues.uf ? props.stateOptions.find(obj => obj.value === defaultFormValues.uf) : null)}
                                                            placeholder="Selecione o estado"
                                                            styles={SelecStyles}
                                                            theme={theme => ({
                                                                ...theme,
                                                                borderRadius: 6,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#CCCCCC',
                                                                    primary: '#1351B4'
                                                                },
                                                            })}
                                                            components={
                                                                {
                                                                    DropdownIndicator,
                                                                    IndicatorSeparator
                                                                }
                                                            }
                                                        />
                                                        {showErroUF &&
                                                        <span className="feedback danger" role="alert" id="cpfoperator">
                                                            <i className="fas fa-times-circle" aria-hidden="true">
                                                                <img
                                                                    src={FailIcon}
                                                                    style={{ paddingBottom: '5px' }}
                                                                    alt="failicon"
                                                                />
                                                            </i>
                                                            Este campo é obrigatório.
                                                        </span>}                                                        
                                                </SelectContainerLeftMargin>
                                            }  
                                            {props.municipalityOptions && (defaultFormValues.abrangencia === 'MUNICIPAL') && (defaultFormValues.uf) &&                                        
                                                <SelectContainerLeftMargin>
                                                    <label>Município<Mandatory>*</Mandatory></label>  
                                                    { props.loadingMunicipality ? <span>carregando...</span>
                                                        :       
                                                        <>                                                   
                                                            <Select
                                                                onChange={(value) => {
                                                                    setDefaultFormValues({ ...defaultFormValues, codigo_municipio: value.value });
                                                                    if (value) {
                                                                        setShowErroMunicipality(false); //Limpa erro
                                                                    }
                                                                }}
                                                                options={props.municipalityOptions}
                                                                value={ (defaultFormValues.codigo_municipio ? props.municipalityOptions.find(obj => obj.value === defaultFormValues.codigo_municipio) : null)}
                                                                placeholder="Selecione o município"
                                                                styles={SelecStyles}
                                                                theme={theme => ({
                                                                    ...theme,
                                                                    borderRadius: 6,
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: '#CCCCCC',
                                                                        primary: '#1351B4'
                                                                    },
                                                                })}
                                                                components={
                                                                    {
                                                                        DropdownIndicator,
                                                                        IndicatorSeparator
                                                                    }
                                                                }
                                                            />
                                                            {showErroMunicipality &&
                                                            <span className="feedback danger" role="alert" id="cpfoperator">
                                                                <i className="fas fa-times-circle" aria-hidden="true">
                                                                    <img
                                                                        src={FailIcon}
                                                                        style={{ paddingBottom: '5px' }}
                                                                        alt="failicon"
                                                                    />
                                                                </i>
                                                                Este campo é obrigatório.
                                                            </span>}        
                                                        </>
                                                    }                                                
                                                </SelectContainerLeftMargin>
                                            }
                                        </ContentContainerBlock>
                                    }
                                    {!props.onSubmitData &&
                                        <>
                                            <ContentContainer11>
                                                <label>Abrangência do atendimento</label>
                                                <span>{agencyScopeEnum.getLabelByValue(props.agency.abrangencia)}</span>
                                            </ContentContainer11>

                                            { ((defaultFormValues.abrangencia === 'ESTADUAL') || (defaultFormValues.abrangencia === 'MUNICIPAL')) &&
                                                <ContentContainer11>
                                                    <label>Estado (UF)</label>
                                                    <span>{estados.find(e => e.value === props.agency.uf)?.label}</span>
                                                </ContentContainer11>
                                            }
                                            
                                            { (defaultFormValues.abrangencia === 'MUNICIPAL') &&
                                                <ContentContainer11>
                                                    <label>Município</label>
                                                    <span>{props.agency.nome_municipio}</span>
                                                </ContentContainer11>
                                            }
                                        </>
                                    }                                    
                                    
                                    {props.onSubmitData &&
                                        <ContentContainerBlock>
                                            <SelectContainer>
                                                <label>Horário padrão de atendimento<Mandatory>*</Mandatory></label>
                                                <Select
                                                    onChange={(value) => {
                                                        setDefaultFormValues({ ...defaultFormValues,  horarios: value.value }); //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                        setHorarioPadraoAtendimento(value);
                                                        console.log("value : " + value)
                                                        if (value) {
                                                            setShowErroAgencyWorkingHours(false); //Limpa erro
                                                        }
                                                    }}
                                                    options={props.workingHoursOptions}
                                                    value = {horarioPadraoAtendimento}
                                                    placeholder="Selecione o horário padrão de atendimento"
                                                    styles={SelecStyles}
                                                    theme={theme => ({
                                                        ...theme,
                                                        borderRadius: 6,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#CCCCCC',
                                                            primary: '#1351B4'
                                                        },
                                                    })}
                                                    components={
                                                        {
                                                            DropdownIndicator,
                                                            IndicatorSeparator
                                                        }
                                                    }
                                                />
                                                {showErroAgencyWorkingHours &&
                                                <span className="feedback danger" role="alert" id="cpfoperator">
                                                    <i className="fas fa-times-circle" aria-hidden="true">
                                                        <img
                                                            src={FailIcon}
                                                            style={{ paddingBottom: '5px' }}
                                                            alt="failicon"
                                                        />
                                                    </i>
                                                    Este campo é obrigatório.
                                                </span>}
                                                
                                            </SelectContainer> 

                                            <button className="br-button primary ml-5" type="button"
                                                onClick={() => setModalAdicionarNovoHorarioVisible(true)}>
                                                Novo horário de atendimento padrão
                                            </button>
                                        </ContentContainerBlock>
                                    }
                                    {!props.onSubmitData &&
                                        <ContentContainer11>
                                            <label>Horário padrão de atendimento</label>
                                            {horarioPadraoLabelFactory(props.agency.horarios, true).map(item => {
                                                return(<span>{item.label}</span>) 
                                            })}
                                        </ContentContainer11>
                                    }                                                                
                                </ContentContainer13>
                            </ContentContainer12>

                            <label>Credenciamento e Autorização</label>
                            <ContentContainer12>
                                <ContentContainer13>
                                    <ContentContainer11>
                                        <InputContainerCheckbox>
                                            <input
                                                id="atendimento_presencial-checkbox"
                                                name="atendimento_presencial"
                                                type="checkbox"
                                                checked={defaultFormValues.atendimento_presencial}
                                                onChange={e => { setDefaultFormValues({ ...defaultFormValues, atendimento_presencial: !defaultFormValues.atendimento_presencial }); }}
                                                disabled={!props.onSubmitData}
                                            />
                                            <label htmlFor="atendimento_presencial-checkbox">Participa do Programa de Atendimento Presencial Balcão GOV.BR</label>
                                        </InputContainerCheckbox>                                                
                                    </ContentContainer11>
                                    <ContentContainer11>
                                    {props.onSubmitData &&
                                        <div className="br-input">
                                            <label htmlFor="data_credenciamento">Data de credenciamento/autorização</label>
                                            <input
                                                style={{width: '300px'}}
                                                id="data_credenciamento-input"
                                                name="data_credenciamento"
                                                type="date"
                                                data-input="data-input"
                                                placeholder="dd/mm/aaaa"
                                                value={defaultFormValues.data_credenciamento ? defaultFormValues.data_credenciamento.split('T')[0]: defaultFormValues.data_credenciamento}
                                                onChange={e => { setDefaultFormValues({ ...defaultFormValues, data_credenciamento: e.target.value }); props.setMsgErrorAccreditationDate(undefined) }}                                                
                                            />
                                            {props.msgErrorAccreditationDate &&
                                                <span className="feedback danger mt-1" role="alert" id="cpfoperator">
                                                    <i className="fas fa-times-circle" aria-hidden="true">
                                                        <img
                                                            src={FailIcon}
                                                            style={{ paddingBottom: '5px' }}
                                                            alt="failicon"
                                                        />
                                                    </i>
                                                    {props.msgErrorAccreditationDate}
                                                </span>
                                            }
                                        </div>
                                    }
                                    {!props.onSubmitData &&
                                        <>
                                            <label htmlFor="data_credenciamento">Data de credenciamento/autorização</label>
                                            <div>
                                                <span>{formatDateDDMMYYYY(defaultFormValues.data_credenciamento)}</span>
                                            </div>
                                        </>
                                    }                                                
                                    </ContentContainer11>
                                    <ContentContainer11>
                                    {props.onSubmitData &&
                                        <div className="br-input">
                                            <label htmlFor="referencia_autorizacao">Referência do processo de autorização{defaultFormValues.data_credenciamento ? <Mandatory>*</Mandatory> : ''}</label>
                                            <input
                                                id="referencia_autorizacao-input"
                                                name="referencia_autorizacao"
                                                type="text"
                                                data-input="data-input"
                                                placeholder="Informe a referência do processo de autorização"
                                                defaultValue={defaultFormValues.referencia_autorizacao}
                                                disabled={!defaultFormValues?.data_credenciamento}
                                                onInput={e => { setDefaultFormValues({ ...defaultFormValues, referencia_autorizacao: e.target.value }); setShowErroAgencyReferenciaAutorizacao(false); }} //Foi usado o onInput ao invés do onChange para corrigir um bug que ocorre quando se seleciona o dado e o apaga usando o botão "Del"
                                                style={{
                                                    "padding": "0px 7px 0px",
                                                    "fontSize": "14px",
                                                    "fontWeight": "normal",
                                                    "color": "#333333"
                                                }}
                                            />
                                            {showErroAgencyReferenciaAutorizacao &&
                                                <span className="feedback danger" role="alert">
                                                    <i className="fas fa-times-circle" aria-hidden="true">
                                                        <img
                                                            src={FailIcon}
                                                            style={{ paddingBottom: '5px' }}
                                                            alt="failicon"
                                                        />
                                                    </i>
                                                    Este campo é obrigatório.
                                                </span>}
                                        </div>
                                    }
                                    {!props.onSubmitData &&
                                        <>
                                            <label htmlFor="referencia_autorizacao">Referência do processo de autorização</label>
                                            <div>
                                                <span>{props.agency.referencia_autorizacao}</span>
                                            </div>
                                        </>
                                    }
                                    </ContentContainer11>
                                </ContentContainer13>
                            </ContentContainer12>
                            <label>Outras Informações</label>
                            <ContentContainer12>
                                <ContentContainer13>
                                    <ContentContainer11>
                                        <InputContainerCheckbox>
                                            <input
                                                id="restricao_usuarios_lotacao-checkbox"
                                                name="restricao_usuarios_lotacao"
                                                type="checkbox"
                                                checked={restricaoUsuariosLotacao}
                                                onChange={e => { restricaoUsuariosLotacao? setModalUserByAllocationRestrictionUncheckedWarningVisible(true) : setRestricaoUsuariosLotacao(!restricaoUsuariosLotacao); setShowErroOrgaoAutorizado(false);}}
                                                disabled={!props.onSubmitData}
                                            />
                                            <label htmlFor="restricao_usuarios_lotacao-checkbox">Restringir o cadastro de usuários por lotação</label>
                                        </InputContainerCheckbox>
                                        {props.onSubmitData &&
                                            <>
                                                {restricaoUsuariosLotacao &&
                                                    <div className="br-input ml-5 mt-1">
                                                        <label htmlFor="orgaos_autorizados-text">Relação de órgãos autorizados</label>
                                                        <input
                                                            id="orgaos_autorizados-text"
                                                            name="orgaos_autorizados"
                                                            type="text"
                                                            placeholder="Informe os códigos dos órgãos autorizados acompanhados por ponto e vírgula (;)."
                                                            defaultValue={defaultFormValues.orgaos_autorizados}
                                                            onChange={e => { setDefaultFormValues({ ...defaultFormValues, orgaos_autorizados: e.target.value }); setShowErroOrgaoAutorizado(false); }}
                                                            disabled={!props.onSubmitData}
                                                            style={{
                                                                        "padding": "0px 7px 0px",
                                                                        "fontSize": "14px",
                                                                        "fontWeight": "normal",
                                                                        "color": "#333333"
                                                                    }}
                                                        />
                                                        {showErroOrgaoAutorizado &&
                                                            <span className="feedback danger" role="alert">
                                                                <i className="fas fa-times-circle" aria-hidden="true">
                                                                    <img
                                                                        src={FailIcon}
                                                                        style={{ paddingBottom: '5px' }}
                                                                        alt="failicon"
                                                                    />
                                                                </i>
                                                                Este campo é obrigatório.
                                                            </span>
                                                        }
                                                    </div>
                                                }                                                     
                                            </> 
                                        }                                           
                                        {!props.onSubmitData &&
                                            <>
                                                {restricaoUsuariosLotacao &&
                                                    <div className="br-input ml-5 mt-1">
                                                        <div>
                                                            <label htmlFor="orgaos_autorizados-text">Relação de órgãos autorizados</label>
                                                        </div>
                                                        <div className="ml-1">
                                                            <span>{props.agency.orgaos_autorizados}</span>
                                                        </div>                                                        
                                                    </div>
                                                } 
                                            </>
                                        }
                                    </ContentContainer11>
                                    <ContentContainer11>
                                        <InputContainerCheckbox>
                                            <input
                                                id="realiza_atendimento-checkbox"
                                                name="realiza_atendimento"
                                                type="checkbox"
                                                checked={defaultFormValues.realiza_atendimento}
                                                onChange={e => { defaultFormValues.realiza_atendimento ? setModalPermissionUncheckedWarningVisible(true) : setDefaultFormValues({ ...defaultFormValues, realiza_atendimento: true }); }}
                                                disabled={!props.onSubmitData}
                                            />
                                            <label htmlFor="realiza_atendimento-checkbox">Autorizada a realizar atendimentos</label>
                                        </InputContainerCheckbox>                                                
                                    </ContentContainer11>
                                    {!props.onSubmitData && props.agency?.motivo_bloqueio &&
                                        <ContentContainer11>
                                            <label>Motivo do bloqueio</label>
                                            <p>{props.agency.motivo_bloqueio}</p>
                                        </ContentContainer11>
                                    }
                                </ContentContainer13>
                            </ContentContainer12>
                            <ContentContainerButtons>
                                {props.onSubmitData &&
                                    <>
                                        <button className="br-button" type="button"
                                            onClick={() => setModalCancelVisible(true)}>
                                            Voltar
                                        </button>

                                        {!props.loadingAdd ?
                                            <button className="br-button primary" type="button"
                                                onClick={() => {
                                                    if (defaultFormValues.data_credenciamento && !defaultFormValues.realiza_atendimento) {
                                                        setModalAccreditationDateWithoutPermissionVisible(true)
                                                    } else if (!defaultFormValues.data_credenciamento && defaultFormValues.realiza_atendimento) {
                                                        setModalPermissionWithoutAccreditationDateVisible(true)
                                                    } else {
                                                        document.getElementById("submitForm").requestSubmit();
                                                    }
                                                } }>
                                                Confirmar
                                            </button>
                                            :
                                            <button className="br-button primary loading" type="button">
                                                Confirmar
                                            </button>
                                        }
                                    </>
                                }

                                {!props.onSubmitData &&
                                    <>
                                        <button className="br-button" type="button"
                                            onClick={() => props.history.push(props.buttonCancelRoute)}>
                                            Voltar
                                        </button>
                                    </>
                                }                        
                            </ContentContainerButtons>
                        </ContentContainer1>
                    </ContentContainer>                   
                </form>
            </GlobalContainer>
        </>
    );
}